var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, getTestId, isLastItem, LILAC_400, scale, Tab, tokens } from '@airtel/air-design-system';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { FlatList, View } from 'react-native';
import { getTabsWidgetStyles } from './TabsWidgetStyles';
export var TabsWidgetComponent = forwardRef((props, ref) => {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$initialSelecte = props.initialSelectedIndex,
    initialSelectedIndex = _props$initialSelecte === void 0 ? 0 : _props$initialSelecte,
    tabStyle = props.tabStyle,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? true : _props$showDivider,
    onUserAction = props.onUserAction,
    style = props.style,
    onPress = props.onPress,
    disableScroll = props.disableScroll,
    onPressHandler = props.onPressHandler,
    _props$useSizeScaling = props.useSizeScaling,
    useSizeScaling = _props$useSizeScaling === void 0 ? false : _props$useSizeScaling,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TabsWidget' : _props$testID,
    showAsPills = props.showAsPills,
    restProps = __rest(props, ["data", "initialSelectedIndex", "tabStyle", "showDivider", "onUserAction", "style", "onPress", "disableScroll", "onPressHandler", "useSizeScaling", "testID", "showAsPills"]);
  var _useState = useState(),
    tabLayout = _useState[0],
    setTabLayout = _useState[1];
  var tabsWidgetStyles = getTabsWidgetStyles(props, tabLayout);
  var listRef = useRef();
  var _useState2 = useState(0),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  useEffect(() => {
    if (initialSelectedIndex >= 0) setTimeout(() => {
      scrollToIndex(initialSelectedIndex);
    }, 100);
  }, [initialSelectedIndex]);
  var scrollToIndex = index => {
    var _a;
    if (index > -1) {
      (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
        index: index,
        animated: true
      });
      setSelectedIndex(index);
    }
  };
  useImperativeHandle(ref, () => {
    return {
      scrollToIndex
    };
  }, []);
  var scaledTabWidth = useMemo(() => {
    return useSizeScaling && scale((tabStyle === null || tabStyle === void 0 ? void 0 : tabStyle.width) || 0);
  }, [tabStyle === null || tabStyle === void 0 ? void 0 : tabStyle.width]);
  var onItemPress = (item, index) => {
    scrollToIndex(index);
    onPressHandler === null || onPressHandler === void 0 ? void 0 : onPressHandler(Object.assign(Object.assign({}, item), {
      index
    }));
    var pressEvent = item.onPress || onPress;
    pressEvent && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(pressEvent, Object.assign({
      index
    }, item)));
  };
  var renderItem = _ref => {
    var item = _ref.item,
      index = _ref.index;
    return _jsx(View, Object.assign({
      style: [tabsWidgetStyles.tabContent, showAsPills && !isLastItem(data, index) && {
        paddingRight: tokens.spacing.SPACING_4
      }]
    }, {
      children: _jsx(Tab, Object.assign({}, item, getTestId(testID, item.text), {
        style: [tabsWidgetStyles.tab, selectedIndex !== index && {
          borderColor: LILAC_400
        }, tabStyle, scaledTabWidth && {
          width: scaledTabWidth
        }, item === null || item === void 0 ? void 0 : item.style],
        type: showAsPills ? 'pill' : 'tab',
        selected: selectedIndex === index,
        onTabPress: () => {
          onItemPress(item, index);
        }
      }))
    }));
  };
  var onScrollToIndexFailed = error => {
    var _a;
    var offset = error.averageItemLength * error.index;
    (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToOffset({
      offset
    });
    setTimeout(() => {
      var _a;
      return (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
        index: error.index
      });
    }, 100);
  };
  return (data === null || data === void 0 ? void 0 : data.length) > 0 && _jsxs(View, Object.assign({
    style: [tabsWidgetStyles.container, style],
    onLayout: event => {
      var _a;
      if ((_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) {
        setTabLayout(event.nativeEvent.layout);
      }
    }
  }, getTestId(testID), restProps, {
    children: [_jsx(FlatList, {
      ref: listRef,
      horizontal: true,
      data: data,
      keyboardShouldPersistTaps: "handled",
      renderItem: renderItem,
      keyExtractor: item => item.text,
      showsHorizontalScrollIndicator: false,
      scrollEnabled: !disableScroll,
      onScrollToIndexFailed: onScrollToIndexFailed
    }), showDivider && _jsx(Divider, {
      height: 2,
      color: LILAC_400,
      style: {
        top: -2,
        zIndex: -1
      }
    })]
  }));
});
TabsWidgetComponent.genericRendererKey = 'AirTabsWidget';